// extracted by mini-css-extract-plugin
export default {"sidepanel":"RightSegment_sidepanel__34Ols","text":"RightSegment_text__GzHmL","title":"RightSegment_title__ukZPW","description":"RightSegment_description__hx+Zb"};